import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { BehaviorSubject } from 'rxjs';
import { User } from '../models/user';

@Injectable()
export class AppState {
    // @ts-ignore
    public user: BehaviorSubject<User> = new BehaviorSubject<User>(null);

    constructor(private router: Router) {
        if (!this.user.getValue()) {
            const user = localStorage.getItem('user');
            this.user.next(JSON.parse(user || '{}') as User);
        }
    }

    public get(prop?: any) {
        return JSON.parse(sessionStorage.getItem(prop) || 'null');
    }

    public set(prop: string, value: any) {
        return sessionStorage.setItem(prop, JSON.stringify(value));
    }

    public updateUser(user: User): void {
        localStorage.setItem('user', JSON.stringify(user));
        this.user.next(user);
    }

    public logOut(): void {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        // @ts-ignore
        this.user.next(null);
        this.router.navigate(['']);
    }
}
